module.exports = __webpack_public_path__ + "static/media/trofeo6.78856fe7.png";